import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomTrustedShopsWidgetComponent } from './custom-trustedshops-widget.component';

@NgModule({
  declarations: [CustomTrustedShopsWidgetComponent],
  exports: [CustomTrustedShopsWidgetComponent],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        StoreReviewsStarsTrustedShopsComponent: {
          component: CustomTrustedShopsWidgetComponent,
        },
      },
    }),
  ],
})
export class CustomTrustedShopsWidgetModule {}
